<template>
  <div v-if="article?.title">
    <SplitContainerAmbition :ambition="article.ambition">
      <template #head>
        <NuxtLink
          class="link-back-to absolute"
          :to="localePath('news')"
        >
          {{ $t('Back to') }} {{ $t('News') }}
        </NuxtLink>

        <div class="page-offset pt-20">
          <div class="grid-side-content sm:gap-5">
            <div class="flex flex-col">
              <div class="date pb-2.5 lg:pb-5">
                {{ formatDate(new Date(article.date), 'dd MMMM yyyy') }}
              </div>
              <div class="heading-detail lg:text-[2.5rem]">
                {{ article.title }}
              </div>
            </div>
            <SofieText
              class="prose prose-invert pb-2.5 !text-white"
              :class="article.ambition?.slug === 'markt-en-economie' ? 'prose-a:text-purple' : ''"
              :value="article.text"
            />
          </div>
        </div>
      </template>

      <template #split>
        <img
          v-if="article.active_image"
          class="image aspect-long my-2.5 lg:my-10 lg:h-96"
          :src="article.active_image?.url"
          :alt="article.title"
        >
      </template>

      <template
        v-if="article.extra_text"
        #default
      >
        <div class="grid-side-content grid gap-5 py-5 lg:pb-7 lg:pt-8">
          <div>
            <h2
              v-if="article.extra_title"
              class="title heading lg:mb-8"
            >
              {{ article.extra_title }}
            </h2>
            <SharePage
              :label="$t('Share this article')"
              :title="article.title"
            />
          </div>
          <div>
            <SofieText
              class="prose prose-headings:text-blue"
              :value="article.extra_text"
            />
          </div>
        </div>
      </template>
    </SplitContainerAmbition>

    <ContactJoin
      v-if="locale === 'nl'"
      class="my-5 lg:my-20"
    />
  </div>
</template>

<script setup lang="ts">
const article = await useArticle(useRoute().params.slug);

const color = article?.ambition?.color ?? '#4E5F7E';

const formatDate = useLocaleDate();
const localePath = useLocalePath();

const {locale} = useI18n();
</script>

<style scoped>
.title {
  --test: v-bind(color);

  color: var(--test);
}
</style>
